const init = () => {
    var $component = $(".c-book-audio");
    if (!$component.length) return;

    var audio = $component.find('audio')[0];
    var $playBtn = $component.find('.c-book-audio__play');
    var $time = $component.find('.c-book-audio__time');
    var $seek = $component.find('.c-book-audio__seek');
    var $progress = $component.find('.c-book-audio__progress');

    $playBtn.click(togglePlay);
    audio.addEventListener('timeupdate', onTimeUpdate);
    audio.addEventListener('ended', onEnded)
    $seek.click(/*onSeekClick*/togglePlay);
    //$seek.on('mousemove', onSeekMouseMove);

    function onTimeUpdate() {
        $time.text(getFormattedTime());
        var percentage = (audio.currentTime / audio.duration).toFixed(2) * 100;
        $progress.width(percentage + '%');
    }

    function onEnded() {
        $component.removeClass('is-playing');
        $progress.width(0);
        audio.currentTime = 0;

        // timeupdate event fires after ended changing text
        _.delay(function() {
            $time.text('Play sample');
        }, 10);
    }

    function getFormattedTime() {
        var timeLeft = audio.duration - audio.currentTime;
        var currentMinute = parseInt(timeLeft / 60) % 60;
        var currentSecondsLong = timeLeft % 60;
        var currentSeconds = currentSecondsLong.toFixed();
        var mins = (currentMinute < 10) ? '0' + currentMinute : currentMinute;
        var secs = (currentSeconds < 10) ? '0' + currentSeconds : currentSeconds;
        return mins + ":" + secs;
    }

    // set seek intent feedback
    function onSeekMouseMove(e) {

        if (audio.currentTime === 0) {
            return;
        }

        var x = e.pageX - $seek.offset().left;
        
    }

    function onSeekClick(e) {

        if (audio.currentTime === 0) {
            togglePlay();
            return;
        }

        var percent = e.offsetX / this.offsetWidth;
        audio.currentTime = percent * audio.duration;
        audio.play();
        $component.addClass('is-playing');
    }

    function togglePlay() {
        if (audio.paused === false) {
            audio.pause();
            $component.removeClass('is-playing');
        } else {
            audio.play();
            $component.addClass('is-playing');
        }
    }

}

export default init;
